module.exports = __webpack_public_path__ + "media/images/search-4ed09da8954deb3af00f82b04291f708.svg";